import React from "react";
import { StyleSheet, Text, View } from "@react-pdf/renderer";
import Thead from "./Thead";
import Tbody from "./Tbody";

/**
 * This component is used to render the table.
 * @param {object} props - The props object.
 * @param {JSX.Element} props.children - The children of the table.
 * @param {object} props.addStyle - The additional style of the table.
 * @param {object} props.replaceStyle - The replace style of the table.
 * @returns {JSX.Element} - The component JSX element.
 */
export const Table = ({ children, addStyle, replaceStyle }) => {
  const styles = StyleSheet.create({
    table: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
  });
  return (
    <View
      style={[
        replaceStyle ? replaceStyle : styles.table,
        addStyle ? addStyle : {},
      ]}
    >
      {children}
    </View>
  );
};

Table.Thead = Thead;
Table.Tbody = Tbody;

export default Table;
